// global components
import DashboardUI from "@qoala-engineering/dashboard-ui";

import Vue from "vue";

Vue.use(DashboardUI);
